<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'employee/index' }">
                                Pegawai BTA
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Detail Pegawai BTA
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col-auto" v-if="roleElligibleModified()">
                <button type="button" class="btn btn-danger btn-sm font-weight-medium mt-4 mb-2 px-5" v-on:click="modalShow = true">
                    Hapus Pegawai
                </button>
            </div>
        </div>
        <div class="row mb-3 mt-4">
            <div class="col-12">
                <form v-on:submit.prevent="save" disabled>
                    <div class="row justify-content-end">
                        <div class="col-auto py-2">
                            <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Jabatan</label>
                        </div>
                        <div class="col">
                            <div class="wrapper-input">
                                <div class="form-check form-check-inline py-1" v-for="role in roles">
                                    <div class="custom-control custom-checkbox">
                                        <input v-model="form.employee.roles" type="checkbox" class="custom-control-input" v-bind:value="role.id" v-bind:id="'input-position-' + role.id" />
                                        <label class="custom-control-label h4" v-bind:for="'input-position-' + role.id">{{ role.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <input v-bind:value="listRoles()" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                        </div>
                        <div class="col-auto" v-if="profile.isAdmin">
                            <div class="edit-action">
                                <button type="button" class="btn btn-link h4 my-0" v-on:click="toggleInput">
                                    Edit
                                </button>
                            </div>
                            <div class="input-action">
                                <button type="submit" class="btn btn-link h4 my-0 mr-2">
                                    Save
                                </button>
                                <button type="button" class="btn btn-link h4 my-0" v-on:click="toggleInput">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2" v-if="additionalForm.hasBranchOption">
                        <div class="col-auto py-2">
                            <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Cabang</label>
                        </div>
                        <div class="col">
                            <div class="wrapper-input">
                                <div class="form-check form-check-inline py-1" v-for="branch in branches">
                                    <div class="custom-control custom-radio">
                                        <input v-model="form.employee.branchID" type="radio" class="custom-control-input" v-bind:value="branch.id" v-bind:id="'input-branch-' + branch.id" />
                                        <label class="custom-control-label h4" v-bind:for="'input-branch-' + branch.id">{{ branch.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <input v-bind:value="guessBranch.name" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                        </div>
                    </div>
                    <div class="row mb-2" v-if="additionalForm.hasSubjectOption">
                        <div class="col-auto py-2">
                            <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Mata Pelajaran Korbid</label>
                        </div>
                        <div class="col">
                            <div class="wrapper-input">
                                <div class="form-check form-check-inline py-1" v-for="subject in subjects">
                                    <div class="custom-control custom-radio">
                                        <input v-model="form.employee.subjectID" type="radio" v-bind:value="subject.id" class="custom-control-input" v-bind:id="'input-subject-id-' + subject.id" />
                                        <label class="custom-control-label" v-bind:for="'input-subject-id-' + subject.id">{{ subject.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <input v-if="employee.isCoordinator" v-bind:value="employee.coordinator.subject.name" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                        </div>
                    </div>
                    <div class="row mb-2" v-if="additionalForm.hasSubjectsOption">
                        <div class="col-auto py-2">
                            <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Mata Pelajaran Pengajar</label>
                        </div>
                        <div class="col">
                            <div class="wrapper-input">
                                <div class="form-check form-check-inline py-1" v-for="subject in subjects">
                                    <div class="custom-control custom-checkbox">
                                        <input v-model="form.employee.subjectIDs" type="checkbox" v-bind:value="subject.id" class="custom-control-input" v-bind:id="'input-subject-ids-' + subject.id" />
                                        <label class="custom-control-label" v-bind:for="'input-subject-ids-' + subject.id">{{ subject.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <input v-if="employee.isTeacher" v-bind:value="listRelations(employee.teacher.subjects)" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <!-- Section 1 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Profil Pegawai
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3 align-items-center">
                                <div class="col-12">
                                    <div v-bind:style="'background-image: url(' + imagePreview +')'" class="user-avatar rounded-circle">
                                        <div class="overlay rounded-circle text-center text-white" v-on:click="$refs.upload.click()">
                                            <i class="fa fa-upload"></i>
                                        </div>
                                        <input ref="upload" type="file" class="form-control" v-on:change="preview" accept="image/*" />
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Username</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.username" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Nama Lengkap</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.name" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Nama Panggilan</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.shortname" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Inisial</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-if="profile.isAdmin" v-model="form.employee.initial" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                    <h4 v-else class="mb-0 font-weight-medium">{{ employee.initial }}</h4>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['tempat_lahir']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Tanggal Lahir</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <datepicker v-model="form.profile.tanggal_lahir" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                    </div>
                                    <input v-if="form.profile.tanggal_lahir" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(form.profile.tanggal_lahir, 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Jenis Kelamin</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <div class="form-check form-check-inline py-1" v-for="gender in ['Laki-laki', 'Perempuan']">
                                            <div class="custom-control custom-radio">
                                                <input v-model="form.profile.jenis_kelamin" type="radio" class="custom-control-input" v-bind:value="gender" v-bind:id="'input-jenis_kelamin-' + gender" />
                                                <label class="custom-control-label h4" v-bind:for="'input-jenis_kelamin-' + gender">{{ gender }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <input disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" v-bind:value="form.profile.jenis_kelamin"/>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['agama', 'status_pernikahan']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="col-md-4 col-sm-12">
                <!-- Section 2 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Kontak Pegawai
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center" v-for="attribute in ['alamat', 'rt_rw', 'kel_kec_kota', 'kode_pos', 'telp_rumah']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">No. HP</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.phone" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Alamat Email</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.employee.email" type="email" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['alumnus_bta', 'joined_at_bta']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-4 col-sm-12">
                <!-- Section 3 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Histori Pendidikan
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center" v-for="attribute in ['asal_sd', 'lulus_sd', 'asal_smp', 'lulus_smp', 'asal_sma', 'lulus_sma', 'asal_univ', 'fakultas_univ', 'jurusan_univ', 'lulus_univ']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4 col-sm-12">
                <!-- Section 4 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Data Keluarga Pegawai
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center" v-for="attribute in ['nama_pasangan', 'tempat_lahir_pasangan']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir Pasangan</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <div class="wrapper-input">
                                        <datepicker v-model="form.profile.tanggal_lahir_pasangan" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                    </div>
                                    <input v-if="form.profile.tanggal_lahir_pasangan" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(form.profile.tanggal_lahir_pasangan, 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['jumlah_anak']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <template v-for="n in 5">
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nama Anak {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile['nama_anak_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tempat Lahir Anak {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile['tempat_lahir_anak_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir Anak {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <div class="wrapper-input">
                                            <datepicker v-model="form.profile['tanggal_lahir_anak_' + n]" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                        </div>
                                        <input v-if="form.profile['tanggal_lahir_anak_' + n]" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(form.profile['tanggal_lahir_anak_' + n], 'YYYY-MM-DD').format('D MMMM YYYY')" />
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-4 col-sm-12">
                <!-- Section 5 -->
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Data Kepegawaian
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Golongan</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-if="profile.isAdmin" v-model="form.profile.golongan" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    <h4 v-else-if="form.profile.golongan" class="mb-0 font-weight-medium">{{ employee.additionals.golongan }}</h4>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['nomor_ktp']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">NIP</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-if="profile.isAdmin" v-model="form.employee.identity" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    <h4 v-else class="mb-0 font-weight-medium">{{ employee.identity }}</h4>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-for="attribute in ['nomor_npwp', 'nomor_rekening', 'bank_rekening', 'nama_rekening']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <b-modal v-model="modalShow" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus Pegawai ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modalShow = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Datepicker from 'vuejs-datepicker';
    import { id } from 'vuejs-datepicker/dist/locale';
    import { employeeRoles, ROLE_EMPLOYEE_BRANCH_STAFF, ROLE_EMPLOYEE_TEACHER, ROLE_EMPLOYEE_COORDINATOR, ROLE_EMPLOYEE_MENTOR, ROLE_EMPLOYEE_BRANCH_HEAD } from '@/params.js';

    export default {
        name: "EmployeeView",
        components: {
            Datepicker
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    employee: {
                        name: '', identity: '', email: '', shortname: '', initial: '', phone: '', image: '', branchID: '', subjectID: '', roles: [], subjectIDs: []
                    },
                    profile: {
                        golongan: '', nomor_npwp: '', nomor_ktp: '', jenis_kelamin: 'Laki-laki', tempat_lahir: '', tanggal_lahir: '', agama: '',
                        bank_rekening: '', nomor_rekening: '', nama_rekening: '',
                        alamat: '', rt_rw: '', kel_kec_kota: '', kode_pos: '', telp_rumah: '',
                        asal_sd: '', lulus_sd: '', asal_smp: '', lulus_smp: '', asal_sma: '', lulus_sma: '', asal_univ: '', fakultas_univ: '', jurusan_univ: '', lulus_univ: '',
                        alumnus_bta: '', joined_at_bta: '',
                        status_pernikahan: '', nama_pasangan: '', tempat_lahir_pasangan: '', tanggal_lahir_pasangan: '', jumlah_anak: '',
                        nama_anak_1: '', tempat_lahir_anak_1: '', tanggal_lahir_anak_1: '',
                        nama_anak_2: '', tempat_lahir_anak_2: '', tanggal_lahir_anak_2: '',
                        nama_anak_3: '', tempat_lahir_anak_3: '', tanggal_lahir_anak_3: '',
                        nama_anak_4: '', tempat_lahir_anak_4: '', tanggal_lahir_anak_4: '',
                        nama_anak_5: '', tempat_lahir_anak_5: '', tanggal_lahir_anak_5: ''
                    }
                },
                employee: {additionals: {}},
                modalShow: false,
                branches: [],
                subjects: [],
                roles: [],
                imagePreview: '',
                dateLanguage: id,
                guessBranch: {},
                additionalForm: {
                    hasBranchOption: false,
                    hasSubjectOption: false,
                    hasSubjectsOption: false
                }
            };
        },
        watch: {
            'form.employee.roles': {
                handler(newRoles) {
                    this.additionalForm.hasBranchOption = [ROLE_EMPLOYEE_BRANCH_STAFF, ROLE_EMPLOYEE_MENTOR, ROLE_EMPLOYEE_BRANCH_HEAD].some(role => newRoles.includes(role));
                    this.additionalForm.hasSubjectsOption = newRoles.includes(ROLE_EMPLOYEE_TEACHER);
                    this.additionalForm.hasSubjectOption = newRoles.includes(ROLE_EMPLOYEE_COORDINATOR);
                },
                deep: true
            }
        },
        methods: {
            save(event) {
                var formData = new FormData();
                for (var group in this.form) {
                    for (var attribute in this.form[group]) {
                        var value = this.form[group][attribute];
                        if (value instanceof Date) {
                            formData.set(group + '[' + attribute + ']', this.$moment(value).format('YYYY-MM-DD'));
                        } else if (Array.isArray(value)) {
                            for (var i = 0; i < value.length; i++) {
                                formData.append(group + '[' + attribute + '][]', value[i]);
                            }
                        } else {
                            formData.set(group + '[' + attribute + ']', value);
                        }
                    }
                }
                this.axios.post(process.env.API_URL + '/employee/update/' + this.employee.userID, formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.toggleInput(event);
                        if (this.profile.id === this.employee.userID) {
                            this.$store.dispatch('setProfile', {requestOptions: {meta: {throwError: false}}});
                        }
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            remove() {
                this.axios.post(process.env.API_URL + '/employee/delete/' + this.employee.userID).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'employee/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modalShow = false;
                });
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.employee.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.fetchEmployee();
                    }
                } else {
                    this.fetchEmployee();
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            listRelations(relations) {
                return typeof relations !== typeof undefined ? relations.map(object => object.name).join(', ') : '';
            },
            listRoles() {
                return this.listRelations(this.roles.filter(object => this.form.employee.roles.includes(object.id)));
            },
            fetchEmployee() {
                this.axios.get(process.env.API_URL + '/employee/' + this.$route.params.id).then(response => {
                    this.employee = response.data.data;
                    this.imagePreview = this.employee.imageUrl;

                    for (var key in this.employee) {
                        if (typeof this.employee[key] !== 'object') {
                            this.form.employee[key] = this.employee[key];
                        }
                    }
                    this.form.employee = Object.assign(this.form.employee, {
                        name: this.employee.user.name,
                        username: this.employee.user.username,
                        email: this.employee.user.email ? this.employee.user.email : '',
                        image: '',
                        branchID: '',
                        subjectID: '',
                        subjectIDs: [],
                        roles: []
                    });
                    for (var i in employeeRoles) {
                        if (this.employee['is' + employeeRoles[i].id]) {
                            this.form.employee.roles.push(employeeRoles[i].id);
                        }
                    }
                    var currentRoles = this.form.employee.roles;
                    if ([ROLE_EMPLOYEE_BRANCH_STAFF, ROLE_EMPLOYEE_MENTOR, ROLE_EMPLOYEE_BRANCH_HEAD].some(role => currentRoles.includes(role))) {
                        this.additionalForm.hasBranchOption = true;

                        if (currentRoles.includes(ROLE_EMPLOYEE_BRANCH_STAFF)) {
                            this.guessBranch = this.employee.branchStaff.branch;
                        } else if (currentRoles.includes(ROLE_EMPLOYEE_MENTOR)) {
                            this.guessBranch = this.employee.mentor.branch;
                        } else if (currentRoles.includes(ROLE_EMPLOYEE_BRANCH_HEAD)) {
                            this.guessBranch = this.employee.branchHead.branch;
                        }
                        this.form.employee.branchID = this.guessBranch.id;
                    }
                    if (currentRoles.includes(ROLE_EMPLOYEE_TEACHER)) {
                        this.additionalForm.hasSubjectsOption = true;

                        this.form.employee.subjectIDs = this.employee.teacher.subjects.map(subject => subject.id);
                    }
                    if (currentRoles.includes(ROLE_EMPLOYEE_COORDINATOR)) {
                        this.additionalForm.hasSubjectOption = true;

                        this.form.employee.subjectID = this.employee.coordinator.subjectID;
                    }
                    this.form.profile = this.employee.additionals;

                    document.title = this.employee.user.name + ' - ' + process.env.APP_NAME;
                });
            },
            roleElligibleModified() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isCoordinator || this.profile.employee.isBranchStaff));
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/branch'),
                this.axios.get(process.env.API_URL + '/subject')
            ]).then(this.axios.spread(function (responseBranch, responseSubject) {
                this.branches = responseBranch.data.data;
                this.subjects = responseSubject.data.data;
            }.bind(this)));

            this.roles = employeeRoles;
        },
        mounted() {
            this.fetchEmployee();
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{ display: none; }
    .btn.btn-outline-white { border-color: #fff; }
    .card-body { padding-left: 1.9rem; padding-right: 1.9rem; }

    form[disabled] .user-avatar .overlay{ display: none; }
    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }

    form[disabled] select.form-control-plaintext { -moz-appearance: none; -webkit-appearance: none; appearance: none; }
    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }
</style>


// WEBPACK FOOTER //
// src/components/employee/View.vue